const channels = [
  { key: 'facebook', label: 'Facebook', url: process.env.REACT_APP_FACEBOOK_URL },
  { key: 'youtube', label: 'YouTube', url: process.env.REACT_APP_YOUTUBE_URL },
  { key: 'whatsapp', label: 'WhatsApp', url: process.env.REACT_APP_WHATSAPP_URL },
  { key: 'tiktok', label: 'TikTok', url: process.env.REACT_APP_TIKTOK_URL },
];

function SocialIcon({ name }) {
  if (name === 'facebook') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.5 1.6-1.5H17V5c-.3 0-1.4-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2V11H7.7v3h2.7v8h3.1Z"/>
      </svg>
    );
  }
  if (name === 'youtube') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M21.6 7.2a2.8 2.8 0 0 0-2-2C17.9 4.7 12 4.7 12 4.7s-5.9 0-7.6.5a2.8 2.8 0 0 0-2 2A29 29 0 0 0 2 12a29 29 0 0 0 .4 4.8 2.8 2.8 0 0 0 2 2c1.7.5 7.6.5 7.6.5s5.9 0 7.6-.5a2.8 2.8 0 0 0 2-2A29 29 0 0 0 22 12a29 29 0 0 0-.4-4.8ZM10 15.2V8.8l5.5 3.2-5.5 3.2Z"/>
      </svg>
    );
  }
  if (name === 'whatsapp') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M20.5 3.5A11.7 11.7 0 0 0 12.2 0C5.8 0 .6 5.2.6 11.6c0 2 .5 4 1.5 5.7L.5 23l5.8-1.5a11.6 11.6 0 0 0 5.9 1.6h.1c6.4 0 11.6-5.2 11.6-11.6a11.5 11.5 0 0 0-3.4-8Zm-8.3 17.7h-.1a9.7 9.7 0 0 1-4.9-1.3l-.4-.2-3.4.9.9-3.3-.2-.4a9.7 9.7 0 1 1 8.1 4.3Zm5.3-7.2c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.4.2-.7.1a7.8 7.8 0 0 1-2.3-1.4 8.5 8.5 0 0 1-1.6-2c-.2-.3 0-.5.1-.6l.5-.6.3-.5c.1-.2 0-.4 0-.6l-.9-2.1c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 2.9 0 1.7 1.2 3.3 1.4 3.5.2.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .7.8.3 1.6.3 2.2.2.7-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3Z"/>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M15.5 3c.7 2.3 2.1 3.7 4.5 4.2v3.1a8.7 8.7 0 0 1-4.5-1.4v6.2a6.2 6.2 0 1 1-5.4-6.1v3.2a3.1 3.1 0 1 0 2.2 3V3h3.2Z"/>
    </svg>
  );
}

export default function FollowUs({ compact = false }) {
  return (
    <section
      className={compact ? 'cb-follow-us cb-follow-us--compact' : 'cb-follow-us'}
      aria-labelledby={compact ? undefined : 'cb-follow-us-title'}
    >
      {!compact && (
        <div className="cb-follow-us-copy">
          <h2 id="cb-follow-us-title">Suivez-nous</h2>
          <p>Retrouvez ConcoursBF sur nos réseaux.</p>
        </div>
      )}

      {compact && <span className="cb-follow-us-compact-label">Suivez-nous</span>}

      <div className="cb-follow-us-links" aria-label="Réseaux sociaux de ConcoursBF">
        {channels.map((channel) => channel.url ? (
          <a
            key={channel.key}
            href={channel.url}
            target="_blank"
            rel="noopener noreferrer"
            className={'cb-social-link cb-social-link--' + channel.key}
            aria-label={'Suivre ConcoursBF sur ' + channel.label}
            title={channel.label}
          >
            <SocialIcon name={channel.key} />
          </a>
        ) : (
          <span
            key={channel.key}
            className={'cb-social-link cb-social-link--disabled cb-social-link--' + channel.key}
            aria-label={channel.label + ' — lien à configurer'}
            title={channel.label + ' — lien à configurer'}
          >
            <SocialIcon name={channel.key} />
          </span>
        ))}
      </div>
    </section>
  );
}
